// src/services/socketService.js
import { io } from "socket.io-client";

let socket = null;

export function getSocket() {
  if (!socket) {
    const url = process.env.REACT_APP_SOCKET_URL || undefined;
    socket = io(url, {
      transports: ["websocket", "polling"],
      withCredentials: true,
      autoConnect: false, // we control when to connect
    });
  }
  return socket;
}

export function connectSocket({ url, auth } = {}) {
  const s = getSocket();
  if (auth) s.auth = auth; // set before connect
  if (!s.connected) s.connect();
  return s;
}

export function disconnectSocket() {
  const s = getSocket();
  if (s.connected) s.disconnect();
}
